jQuery(($) => {

    if ($('.o-notification-bar')[0]) {
        if (localStorage.getItem('notificationBarState') != 'shown') {
            $('.o-notification-bar').show();

            $('.o-header').addClass('o-header--notification');
        } else {
            $('.o-notification-bar').remove();
        }

        $('.js-close-notification-bar').click(function () {
            localStorage.setItem('notificationBarState', 'shown');

            $('.o-notification-bar').remove();

            $('.o-header').removeClass('o-header--notification');

            $(this).remove();
        })
    }
}); 